// This is generated.  Alter it in blockGroups/actionElements/types/MenuButton.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context = {},
    parentAccessRestrictions,
  ) {
    const { namespace, relation, withSelection } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    // MenuButton doesn't have a forAction - it's a container for menu items that may have their own actions
    // Default access context allows GET only since menu buttons themselves don't perform CRUD
    const accessContext = {
      get: { value: true },
      post: { value: false },
      patch: { value: false },
      remove: { value: false },
    };

    // Respect read-only restrictions
    if (accessRestrictions.readOnly) {
      accessContext.post.value = false;
      accessContext.patch.value = false;
      accessContext.remove.value = false;
    }

    // Build an (extendable) relation schema; additionalProperties: true so other nodes can add props.
    const relationSchema = Type.Object(
      {},
      {
        title: relation,
        additionalProperties: true,
        'x-accessRestrictions': accessRestrictions,
        'x-accessContext': accessContext,
      },
    );

    // subDataDictionary defines the namespace/relation structure for metadata assembly
    const subDataDictionary = {
      [namespace]: {
        [relation]: relationSchema,
      },
    };

    // MenuButton does not contribute local properties to the form
    const partialTypeDefinition = {};

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'actionElements',
  'MenuButton',
  module.exports,
);
